import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import LearnerTrack from './pages/LearnerTrack';
import PractitionerTrack from './pages/PractitionerTrack';
import Tutor from './pages/Tutor';
import Resources from './pages/Resources';

function App() {
  return (
    <div className="app">
      <div style={{ background: "#080c14", padding: "8px 0", borderBottom: "1px solid rgba(100,116,139,0.15)" }}><div style={{ maxWidth: 900, margin: "0 auto", padding: "0 20px" }}><a href="https://navigationalmind.com" style={{ fontFamily: "monospace", fontSize: 13, color: "#e2e8f0", textDecoration: "none", letterSpacing: "0.5px", display: "inline-flex", alignItems: "center", gap: 6 }}>← navigationalmind.com</a></div></div>
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/learner" element={<LearnerTrack />} />
          <Route path="/learner/:week" element={<LearnerTrack />} />
          <Route path="/practitioner" element={<PractitionerTrack />} />
          <Route path="/tutor" element={<Tutor />} />
          <Route path="/resources" element={<Resources />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
